<i18n src="./resources/locales.json"></i18n>
<template>
  <v-dialog ref="imageDialog" v-model="dialogOpenState" @click:outside="close" content-class="sms-image-dialog scroller-xy custom-scrollbar">
    <v-btn icon x-large class="sms-image-dialog__full-size-btn" @click="toggleFullSizeView">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon v-if="shouldContain" v-on="on">mdi-fullscreen</v-icon>
          <v-icon v-else v-on="on">mdi-fullscreen-exit</v-icon>
        </template>
        <span v-if="shouldContain">{{ $t('showFullSizeView') }}</span>
        <span v-else>{{ $t('exitFullSizeView') }}</span>
      </v-tooltip>
    </v-btn>
    <v-btn icon x-large class="sms-image-dialog__close-btn" @click="close">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on">mdi-close</v-icon>
        </template>
        <span>{{ $t('close') }}</span>
      </v-tooltip>
    </v-btn>
    <v-img
      ref="img"
      :src="imageSrc"
      max-width="max-content"
      :height="imageHeight"
      :width="imageWidth"
      :contain="shouldContain"
    />
  </v-dialog>
</template>

<script>
export default {
  name: 'SmsImageDialog',

  data() {
    return {
      dialogOpenState: false,
      imageSrc: null,
      imageHeight: undefined,
      imageWidth: undefined,
      shouldContain: true
    };
  },

  mounted() {
    this.$root.$on('open-image-dialog', this.open);
  },

  beforeDestroy() {
    this.$root.$off('open-image-dialog');
  },

  methods: {
    open(imageSrc) {
      this.imageSrc = imageSrc;
      this.dialogOpenState = true;
    },

    close() {
      this.dialogOpenState = false;
      this.imageHeight = undefined;
      this.imageWidth = undefined;
      this.shouldContain = true;
    },

    toggleFullSizeView() {
      if (this.shouldContain) {
        this.imageWidth = this.$refs.img.image.naturalWidth;
        this.imageHeight = this.$refs.img.image.naturalHeight;
      } else {
        this.imageHeight = undefined;
        this.imageWidth = undefined;
      }
      this.shouldContain = !this.shouldContain;
    }
  }
};
</script>

<style>
.sms-image-dialog {
  display: flex;
  position: relative;
  padding: 0;
  max-height: calc(90% - 52px) !important; /* 52px is the close button size (x-large) */
  max-width: 90vw;
  width: fit-content !important;
  height: fit-content !important;
  box-shadow: none;
}

.sms-image-dialog__close-btn {
  position: fixed;
  top: 10px;
  right: 10px;
  color: #FFFFFF !important;
  z-index: 99;
}

.sms-image-dialog__full-size-btn {
  position: fixed;
  width: fit-content;
  top: 10px;
  right: 75px;
  color: #FFFFFF !important;
  z-index: 99;
}
</style>
